module.exports = __webpack_public_path__ + "static/media/_title_14.223a1010.svg";